import MemberPermissionsTag from "common/components/MemberPermissionsTag";
import MobileDetailsDrawer from "common/components/MobileDetailsDrawer";
import MobileDetailsDrawerItem from "common/components/MobileDetailsDrawer/MobileDetailsDrawerItem";
import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import ProfileImage from "common/components/ui/ProfileImage";
import { Tag } from "common/components/ui/Tag";
import { formatDate } from "common/helpers/utils";
import type { Member } from "common/types";

import useMembersActions from "../../../hooks/useMembersActions";
import MemberActions from "../MemberActions";
import MemberStatusTag from "../MemberStatusTag";

interface MobileDrawerContentProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  member: Member;
}

export default function MobileMemberDetails({
  isOpen,
  setIsOpen,
  member,
}: MobileDrawerContentProps) {
  const { actions } = useMembersActions(member);

  const {
    first_name: firstName,
    last_name: lastName,
    role,
    permissions,
    customer_id: memberId,
    email,
    created_at: createdAt,
    status,
  } = member;

  return (
    <MobileDetailsDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      editOptions={actions}
      renderEditComponent={(editKey, onBack) => (
        <MemberActions
          action={editKey}
          member={member}
          onClose={() => setIsOpen(false)}
          onBack={onBack}
        />
      )}
      editTitle="Member options"
    >
      <div className="flex gap-x-2 items-start flex-1 mb-1">
        {status === "pending" ? (
          <ProfileImage size="md" src="" />
        ) : (
          <AimfoxAvatar firstName={firstName} lastName={lastName} size="md" />
        )}

        <div className="flex flex-col gap-y-0.5">
          <span className="text-sm-bold">
            {memberId
              ? `${firstName} ${lastName}`
              : `New ${role === "member" ? "Member" : "Admin"}`}
          </span>
          <p className="text-black-500 text-xs-medium">{email}</p>
        </div>
      </div>

      <MobileDetailsDrawerItem label="Role">
        <MemberPermissionsTag permissions={permissions} role={role} />
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Added">
        <Tag variant="tertiary">{formatDate(createdAt)}</Tag>
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Status">
        <MemberStatusTag memberStatus={status} memberRole={role} size="md" />
      </MobileDetailsDrawerItem>
    </MobileDetailsDrawer>
  );
}
